/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Schedule_Kind_CronInputs */

const cs_schedule_kind_cron = /** @type {(inputs: Schedule_Kind_CronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron`)
};

const en_schedule_kind_cron = /** @type {(inputs: Schedule_Kind_CronInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cron`)
};

/**
* | output |
* | --- |
* | "Cron" |
*
* @param {Schedule_Kind_CronInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const schedule_kind_cron = /** @type {((inputs?: Schedule_Kind_CronInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Schedule_Kind_CronInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_schedule_kind_cron(inputs)
	return cs_schedule_kind_cron(inputs)
});